import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const MobileCarouselDropdown = styled.div`
  @media (min-width: 990px) {
    display: none;
  }
`;

const OfferPageWrapper = styled.div`
  width: 100%;
  height: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  position: relative;
  padding: 100px 60px 60px;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 100px 30px 60px;
  }

  @media (max-width: 1199px) {
    padding: 100px 30px 60px;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: 400px;
  background-color: #f4f4f4;
`;

const MainContentArea = styled.main`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background-color: #ffffff;
  padding-right: 0;
  transition: padding-right 0.35s ease-in-out;
  padding-top: 15vh;
  @media (max-width: 992px) {
    padding-top: 6vh;
  }
  .img_banner{
    width: 100%;
    /* height: 450px; */
    object-fit: cover;
  }
  @media (max-width: 768px) {
    .img_banner{
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .title {
    width: 100%;
    margin: 0 auto;
    @media (min-width: 1200px) {
      width: ${(props) => (props.isFullWidth === 1 ? '100%' : '80%')};
    }
  }
`;

const MainHeader = styled.h1`
  width: 100%;
  text-align: center;
  color: green;
  padding: 20px 0px;
  text-transform: uppercase;
  font-size: 3.5vw;
`;

const SidebarSection = styled.div`
  background-color: #ffffff;
  width: 280px;

  @media (max-width: 990px) {
    display: none;
  }
`;

const ContentSection = styled.div`
  width: calc(100% - 280px);
  height: auto;
  .home_breadCrumb_style{
    a{color: #4b4a49;}
  }
  /* a { color: #4b4a49; } */
  .bread_crumb_wrapper{
      color: #9cc54b !important;
     a{color: #9cc54b !important};
  }
  // min-height: 100vh;
  padding: 30px 30px 50px;
  
  .shop-closed{
    color: #C82525;
    font-weight: bold;
    text-transform: capitalize;
  }

  @media (max-width: 768px) {
    padding: 30px 7.5px 100px;
  }

  @media (max-width: 1199px) and (min-width: 991px) {
    padding: 15px 30px 50px;
  }

  @media (max-width: 1367px) and (min-width: 1200px) {
    padding: 15px 30px 50px;
  }

  @media (max-width: 990px) {
    width: 100%;
    &.contentSection {
      padding-top: 65px;
    }
  }

  @media (max-width: 768px) {
    padding-top: 15px;
    min-height: auto;
  }

  .offer-slider {
    padding: 0 0 30px 30px;
  }
`;

export const ProductTopTitle = styled.div`
    padding-left: 20px;
    font-weight: 700;
    font-size: 2.5rem;
    font-family: "SF-Pro"!important;
    color: rgb(156, 197, 75);
    @media (max-width: 768px) {
      font-size: 2rem;
    }
`;

const OfferSection = styled.div`
  width: 100%;
  height: auto;
  display: block;

  background-color: #ffffff;
  position: relative;
  // border-bottom: 1px solid ${themeGet("colors.borderColor", "#f1f1f1")};

  .prevButton {
    left: 1rem;
    top: 50%;
  }

  .nextButton {
    right: 1rem;
    top: 50%;
  }
  .btn-check-availability:active,
  .btn-check-availability:focus,
  .btn-check-availability:visited,
  .btn-check-availability {
    background-color: #9cc54b;
    border-color: #9cc54b;
    padding-left: 20px;
    padding-right: 20px;
    white-space: nowrap;
    font-size: 21px;
    font-family: "FontAwesome";
    box-shadow: none;
    
    .fa {
      fontSize: 21px;
      color: #FFFFFF;
      margin-right: 5px;
    }
  }

  @media (max-width: 990px) and (min-width: 600px) {
    // padding: 20px 15px;
    .prevButton {
      left: 1rem;
      top: 50%;
    }

    .nextButton {
      right: 1rem;
      top: 50%;
    }
  }
  @media (max-width: 990px) {
    padding-top: 15px;
  }
  
  @media (max-width: 767px) {    
    .btn-check-availability:active,
    .btn-check-availability:focus,
    .btn-check-availability:visited,
    .btn-check-availability {
      font-size: 0.8rem;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`;

const PromoSection = styled.div`
  width: 100%;
  height: auto;
  display: block;
  background-color: rgb(255,255,255);
  position: relative;
  margin-top: 0px;
  box-shadow: rgb(0 0 0 / 20%) 0px 15px 20px -20px;
  // border-bottom: 1px solid ${themeGet("colors.borderColor", "#f1f1f1")};

  .prevButton {
    left: 0rem;
    top: 50%;
  }

  .nextButton {
    right: 0rem;
    top: 50%;
  }

  @media (max-width: 990px) and (min-width: 600px) {
    // padding: 20px 15px;
    .prevButton {
      left: 0rem;
      top: 50%;
    }

    .nextButton {
      right: 0rem;
      top: 50%;
    }
  }
  @media (max-width: 990px) {
    padding-top: 15px;
  }
  @media (max-width: 490px) {
    .prevButton,
    .nextButton {
      display: none;
    }
  }
`;

const BrandSection = styled.div`
  width: 100%;
  height: auto;
  display: block;
  background-color: rgb(255,255,255) !important;
  position: relative;
  margin-top: 20px;
  // border-bottom: 1px solid ${themeGet("colors.borderColor", "#f1f1f1")};

  .prevButton {
    left: 0rem;
    top: 50%;
  }

  .nextButton {
    right: 0rem;
    top: 50%;
  }

  @media (max-width: 990px) and (min-width: 600px) {
    // padding: 20px 15px;
    .prevButton {
      left: 0rem;
      top: 50%;
    }

    .nextButton {
      right: 0rem;
      top: 50%;
    }
  }
  @media (max-width: 990px) {
    padding-top: 15px;
  }
`;

const Heading = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #9cc54b;
  padding: 0px 20px 20px;
  margin: 50px 10px 20px;
  border-bottom: 2px solid #9cc54b;
  width: auto;
  display: inline-block;
`;

const ProductsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  justify-content: center;
  background-color: #f7f7f7;

  @media (max-width: 768px) {
    margin-left: -7.5px;
    margin-right: -7.5px;
    margin-top: 15px;
  }
`;

const ProductsCol = styled.div`
  flex: 0 0 20%;
  max-width: 20%;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 30px;

  @media (max-width: 1650px) {
    flex: 0 0 33.33%;
    max-width: 33.33%;
  }
  @media (max-width: 1300px) {
    flex: 0 0 33.3333333%;
    max-width: 33.3333333%;
  }
  @media (max-width: 1199px) and (min-width: 900px) {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 20px;
  }
  @media (max-width: 899px) and (min-width: 769px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media (max-width: 768px) {
    padding-left: 7.5px;
    padding-right: 7.5px;
    margin-bottom: 15px;
    flex: 0 0 33.3333333%;
    max-width: 33.3333333%;
  }

  @media (max-width: 490px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

const CardWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  padding-bottom: 20px;
  background-color: #fff;
  position: relative;
  text-align: center;
  font-family: "Lato", sans-serif;
  border-radius: 20px;
  cursor: pointer;
`;
const WaitingScreen = styled.div`
  position: fixed;
  top: 0;
  z-index: 1001;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);

  span.spinner-border {
    color: #9cc54b !important;
  }
  @media (min-width: 768px){
    span.spinner-border {
      height: 5rem;
      width: 5rem;
      border: 0.4em solid currentColor;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
  @media (min-width: 425px){
    span.spinner-border {
      height: 3.5rem;
      width: 3.5rem;
      border: 0.3em solid currentColor;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
`;

const FilterWrapper = styled.div`
  background: #fff;
  .bg_blur {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    opacity: 0;
    visibility: hidden;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity .3s ease-in-out;
  }
  .show {
    opacity: 1;
    visibility: visible;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .filter_icon {
    padding-right: 30px;
    font-size: 20px;
    text-align: right;
    cursor: pointner;
  }
  @media (min-width: 768px) {
    .filter_icon {
      padding-right: 100px;
      font-size: 20px;
      text-align: right;
    }
  }
  .label_container {
    display: block;
    position: relative;
    padding-left: 25px;
    margin-bottom: 12px;
    font-size: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /* Hide the browser's default checkbox */
  .label_container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 2px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border: 1px solid #aaa;
  }

  /* On mouse-over, add a grey background color */
  .label_container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .label_container input:checked ~ .checkmark {
    background-color: #2196f3;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .label_container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .label_container .checkmark:after {
    left: 5px;
    top: 1px;
    width: 8px;
    height: 13px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  #sortdropdown {
    color: #fff;
    border: 0px;
  }
  @media (max-width: 990px) {
    .col-sm-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;
const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 30px;
`;

const FilterDiv = styled.div`
  box-sizing: border-box;
  position: fixed;
  z-index: 999999;
  width: auto;
  max-width: 420px;
  background-color: #fff;
  top: 0px;
  left: 0;
  @media (min-width: 1920px) {
      max-width: 720px;
  }
  /* CSS for the modal container */
  .modal {
    /* width: 100vw; */
    /* width: 400px; */
    position: fixed;
    /* width: 0px; */
    left: -100rem;
    /* transform: translate(-50%, -50%); */
    /* background-color: rgba(0, 0, 0, 0.5); */
    /* padding: 20px; */
    /* border-radius: 8px; */
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
  }

  /* CSS for showing the modal */
  .modal.show {
    left: 0;
    /* width: 100vw; */
    max-width: 420px;
    /* transform: translateX(-50%); */
    opacity: 1;
    visibility: visible;
    @media (min-width: 1920px) {
      max-width: 720px;
    }
  }
  /* ma
  }

  /* CSS for fade-in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* CSS for the modal animation */
  .modal.animate {
    animation: fadeIn 0.3s;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
    /* margin: 26px 0px; */
    width: 100%;
    height: auto;
  }
  .col-sm-two {
    margin: 0px 8px;
    
    &.express {
      display: flex;
      justify-content: flex-end;
      flex: 1;
    }
  }
  .col-sm-eight {
    flex: 1;
  }
  ._1q59bef {
    display: inline-block;
    margin-right: 8px;
    border-left: 1px solid #dddddd;
    height: 36px;
  }

  @media screen and (max-width: 600px) {
    .col-sm-eight {
      flex: 0 0 10%;
      max-width: unset;
    }
    .col-sm-two {
      flex: 0 0 25%;
      max-width: unset;
    }
    /*.sort-filter-hide{
     display:none;
   }*/
  }
`;

const FilterModalWrapper = styled.div`
  ._pwbsgx {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    padding-left: 14px !important;
    padding-right: 14px !important;
    border-top: 1px solid rgb(235, 235, 235) !important;
    font-size: 12px;
  }
  ._1qbrhv4 {
    -webkit-box-pack: justify !important;
    -webkit-box-align: center !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
  }
  ._gby1jkw:disabled {
    cursor: not-allowed !important;
    opacity: 1 !important;
    color: rgb(221, 221, 221) !important;
    border-width: initial !important;
    border-style: none !important;
    border-color: initial !important;
    border-image: initial !important;
    background: transparent !important;
  }
  ._gby1jkw {
    cursor: pointer !important;
    display: inline-block !important;
    position: relative !important;
    text-align: center !important;
    width: auto !important;
    touch-action: manipulation !important;
    font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
      "Helvetica Neue", sans-serif !important;
    line-height: 20px !important;
    font-weight: 600 !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    color: rgb(34, 34, 34) !important;
    margin: 0px -10px !important;
    border-radius: 8px !important;
    outline: none !important;
    transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s,
      -webkit-transform 0.1s ease 0s, transform 0.1s ease 0s !important;
    border-width: initial !important;
    border-style: none !important;
    border-color: initial !important;
    border-image: initial !important;
    background: transparent !important;
    text-decoration: underline !important;
  }
  ._ls0e43 {
    margin-left: auto !important;
  }
  ._ajuxzjo {
    cursor: pointer !important;
    display: inline-block !important;
    position: relative !important;
    text-align: center !important;
    width: auto !important;
    touch-action: manipulation !important;
    font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
      "Helvetica Neue", sans-serif !important;
    line-height: 18px !important;
    font-weight: 600 !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
    color: rgb(255, 255, 255) !important;
    margin: 0px !important;
    text-decoration: none !important;
    border-radius: 8px !important;
    outline: none !important;
    transition: box-shadow 0.2s ease 0s, -ms-transform 0.1s ease 0s,
      -webkit-transform 0.1s ease 0s, transform 0.1s ease 0s !important;
    border-width: initial !important;
    border-style: none !important;
    border-color: initial !important;
    border-image: initial !important;
    background: #9cc54b !important;
  }
`;
export {
  OfferPageWrapper,
  HeaderSection,
  MainContentArea,
  SidebarSection,
  ContentSection,
  OfferSection,
  Heading,
  ProductsRow,
  ProductsCol,
  CardWrapper,
  MainHeader,
  PromoSection,
  BrandSection,
  WaitingScreen,
  FilterWrapper,
  ButtonWrapper,
  FilterDiv,
  FilterModalWrapper
};
